(function () {
    const subscriptionProducts = document.querySelectorAll('a.subscription-product');
    const memberChoiceItems = document.querySelectorAll('a.member-choice');
    const addToCartButtons = document.querySelectorAll('.add-to-cart');

    function addToCart() {
        const subscriptionProduct = document.querySelector("a.subscription-product.active");

        // The customer needs to select a product
        if (!subscriptionProduct) {
            return;
        }

        const choiceProduct = document.querySelector('.member-choice.active');

        // Use dataset for data- attributes (data-variant-id -> dataset.variantId)
        const variantId = subscriptionProduct.dataset.variantId;
        const sellingPlanId = subscriptionProduct.dataset.sellingPlanId;
        const choiceVariantId = choiceProduct ? choiceProduct.dataset.variantId : null;

        // A unique timestamp to go along with the cart item.
        // This unique timestamp causes the subscription box to be its own unique line item in the cart (e.g. a subscription box with a quantity of 1 that doesn't increase to 2 upon adding another)
        //
        // This also ties together the subscription box with its free products.
        // There is a script in the "Scripts" app in Shopify Admin which handles removing items with the same _box_num and _free_prod_num properties if someone removes the subscription product from their cart.
        const uniqueNumber = new Date().getTime();

        const data = {
            items: [
                {
                    "id": variantId,
                    "quantity": 1,
                    "selling_plan": sellingPlanId,
                    "properties": {
                        '_box_num': uniqueNumber
                    }
                }
            ]
        };

        if (choiceVariantId) {
            data.items.push({
                "id": choiceVariantId,
                "quantity": 1,
                "properties": {
                    '_free_prod': "true",
                    '_free_prod_num': uniqueNumber
                }
            });
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(() => window.location.href = "/checkout")
            .catch(() => goCart.ajaxRequestFail());
    }

    function enableAddToCartButton() {
        addToCartButtons.forEach(function (button) {
            button.disabled = false;
            button.removeAttribute("disabled");
            button.textContent = "Select";
        });
    }

    function disableAddToCartButton() {
        addToCartButtons.forEach(function (button) {
            button.disabled = true;
            button.setAttribute("disabled", "disabled");
        });
    }

    /** 
     * The event handler for when a subscription product gets selected.
     * This function should show/hide information for the selected subscription and add/remove an `active` CSS class.
     */
    function productSelected(subscriptionProduct, e) {
        if (e) {
            e.preventDefault();
        }

        // Remove "active" class from all subscriptions
        for (let i in subscriptionProducts) {
            if (!subscriptionProducts.hasOwnProperty(i)) {
                continue;
            }

            let otherSubscriptionProduct = subscriptionProducts[i];

            if (otherSubscriptionProduct.classList) {
                otherSubscriptionProduct.classList.remove("active");
            }
        }

        // Add "active" class to the selected subscription
        subscriptionProduct.classList.add("active");

        // Hide elements that don't match the same [data-block-id] as the subscription
        const attributeName = "data-block-id";
        const blockIdElements = document.querySelectorAll("[" + attributeName + "]");
        for (let i in blockIdElements) {
            if (!blockIdElements.hasOwnProperty(i)) {
                continue;
            }

            let blockIdElement = blockIdElements[i];
            if (blockIdElement.getAttribute(attributeName) === subscriptionProduct.id) {
                blockIdElement.classList.remove("d-none");
            } else {
                blockIdElement.classList.add("d-none");
            }
        }
    }

    /**
     * The event handler for when a member choice gets selected.
     * Adds an `active` class to the selected member choice and removes it from the rest.
     */
    function memberChoiceSelected(memberChoiceItem, e) {
        if (e) {
            e.preventDefault();
        }

        for (let i in memberChoiceItems) {
            if (!memberChoiceItems.hasOwnProperty(i)) {
                continue;
            }

            let otherMemberChoiceItem = memberChoiceItems[i];

            if (otherMemberChoiceItem.classList) {
                otherMemberChoiceItem.classList.remove("active");
            }
        }

        memberChoiceItem.classList.add("active");

        enableAddToCartButton();
    }

    // Attach click event handlers to each subscription product
    for (let i in subscriptionProducts) {
        if (!subscriptionProducts.hasOwnProperty(i)) {
            continue;
        }

        let subscriptionProduct = subscriptionProducts[i];
        subscriptionProduct.onclick = function (e) { productSelected(subscriptionProduct, e); };
    }

    // Attach click event handlers to each member choice option
    for (let i in memberChoiceItems) {
        if (!memberChoiceItems.hasOwnProperty(i)) {
            continue;
        }

        let memberChoiceItem = memberChoiceItems[i];
        memberChoiceItem.onclick = function (e) { memberChoiceSelected(memberChoiceItem, e); };
    }

    // If there are no member choice options, enable the Add to Cart button by default
    if (!memberChoiceItems || memberChoiceItems.length === 0) {
        enableAddToCartButton();
    } else {
        disableAddToCartButton();
    }

    // A URL parameter can be used to preselect a subscription option when arriving on the page.
    const urlParams = new URLSearchParams(window.location.search);
    const preselectedSubscriptionId = urlParams.get("product");
    if (preselectedSubscriptionId) {
        for (let i in subscriptionProducts) {
            if (!subscriptionProducts.hasOwnProperty(i)) {
                continue;
            }

            let subscriptionOption = subscriptionProducts[i];

            if (subscriptionOption.dataset && subscriptionOption.dataset.productId === preselectedSubscriptionId) {
                productSelected(subscriptionOption, null);
                break;
            }
        }
    }

    // Get the initially selected subscription product and trigger the event handler to show the correct information
    const subscriptionProduct = document.querySelector("a.subscription-product.active");
    if (subscriptionProduct) {
        productSelected(subscriptionProduct, null);
    }

    addToCartButtons.forEach(function (button) {
        button.onclick = addToCart;
    });
})();